<section class="content">
  <div class="container-fluid">
    <!-- Small boxes (Stat box) -->
    <div class="row" style="padding-top: 1%;">
      <div class="col-lg-3 col-6">
        <!-- small box -->
        <div class="small-box bg-info">
          <div class="inner">
            <h3>{{studentsCount}}</h3>
    
            <p>Registered Student(s)</p>
          </div>
          <div class="icon">
            <i class="ion "></i>
          </div>
          <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
        </div>
      </div>
      <!-- ./col -->
      <div class="col-lg-3 col-6">
        <!-- small box -->
        <div class="small-box bg-success">
          <div class="inner">
            <h3>{{mentorsCount}}</h3>
    
            <p>Registered Mentor(s)</p>
    
    
          </div>
          <div class="icon">
            <i class=" "></i>
          </div>
          <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
        </div>
      </div>
      <div class="col-lg-3 col-6">
        <!-- small box -->
        <div class="small-box bg-warning">
          <div class="inner">
            <h3>{{registerDist}}</h3>
    
            <p>No. of District(s)</p>
          </div>
          <div class="icon">
            <i class="ion "></i>
          </div>
          <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
        </div>
      </div>
      <div class="col-lg-3 col-6">
        <!-- small box -->
        <div class="small-box bg-secondary">
          <div class="inner">
            <h3>{{coursesCount}}
              <!-- <sup style="font-size: 20px">%</sup> -->
            </h3>
    
            <p >No. of Course(s)</p>
          </div>
          <div class="icon">
            <i class="ion "></i>
          </div>
          <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
        </div>
      </div>
      <!-- <div>
            <canvasjs-chart [options]="chartOptions" [styles]="{width: '100%', height:'360px'}"></canvasjs-chart>    
          </div>   -->
    </div>
   
    <div class="row h-auto justify-content-around"   style="gap: 10px;">
      <!-- <div class="col" > -->
       <!-- Applications Overview Bar chart -->
         <!-- <div class="card shadow h-100">
             <div class="card-header" >
                 <h6 class="m-0 font-weight-bold text-primary">District-wise Engineers Overview</h6>
             </div>
             <div class="card-body" >
                 <div >
                     <canvas  id="MyChart" ></canvas>
                 </div>
             </div>
         </div> -->
       <!-- </div>
       <div class="col">
           <div class="card shadow h-100">
             <div class="card-header" >
                 <h6 class="m-0 font-weight-bold text-primary">Branch-wise Engineers</h6>
             </div>
             <div class="card-body" >
                 <div>
                   <canvas id="canvas"></canvas>
                 </div>
             </div>
           </div>
       </div> -->
        <!-- <div class="row">
          <div class="col-md-6 card">
            <div class="card shadow h-100">
              <div class="card-header">
                <h6 class="m-0 font-weight-bold text-primary">District-wise Engineers Overview</h6>
              </div>
              <div class="card-body">
                <div>
                  <div id="donut"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 card">
                  <div class="card shadow h-100">
                    <div class="card-header">
                      <h6 class="m-0 font-weight-bold text-primary">District-wise Engineers Overview</h6>
                    </div>
                    <div class="card-body">
                      <div>
                        <div id="donut2"></div>
                      </div>
                    </div>
                  </div>
                </div>
        </div> -->
          <div class="col-md-12">
            <div class="card shadow h-100">
              <div class="card-header">
                <h6 class="m-0 font-weight-bold text-primary " style="color: #015792 !important;">District wise Students Distribution</h6>
              </div>
              <div class="card-body">
                  
                <div>
                  <div id="graphDiv2"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-12" style="display:none">
            <div class="card shadow h-100">
              <div class="card-header">
                <h6 class="m-0 font-weight-bold text-primary">DistrictWise Office Bearers</h6>
              </div>
              <div class="card-body">
               
                <div>
                  <div id="chartdiv"></div>
                </div>
              </div>
            </div>
          </div> -->
           
            
            <div class="col-md-12" >
              <div class="card shadow h-100">
                <div class="card-header">
                  <h6 class="m-0 font-weight-bold text-primary" style="color: #015792 !important;">District wise Mentors Distribution</h6>
                </div>
                <div class="card-body">
            
                  <div>
                    <div id="graphDiv1"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-md-12">
              <div class="card shadow h-100">
                <div class="card-header">
                  <h6 class="m-0 font-weight-bold text-primary" style="color: #015792 !important; ">Pie Chart</h6>
                </div>
                <div class="card-body">
                  <div>
                    <div id="graphDiv"></div>
                  </div>
                </div>
              </div>
            </div> -->
                <!-- <div class="col-md-12">
                  <div class="card shadow h-100">
                    <div class="card-header">
                      <h6 class="m-0 font-weight-bold text-primary">Consolidated Office Bearer Drilldown Chart</h6>
                    </div>
                    <div class="card-body">
                
                      <div>
                        <div id="chartDiv5"></div>
                      </div>
                    </div>
                  </div>
                </div> -->

                <style>
                  /* Default styles */
                  #chartdiv,
                  #graphDiv,
                  #graphDiv1,
                  #chartDiv5,
                  #graphDiv2,
                  #donut,
                  #donut2 {
                    width: 100%;
                    height: 500px;
                  }
                
                  /* Media query for smaller devices */
                  @media screen and (max-width: 768px) {
                    #chartdiv,
                    #graphDiv,
                    #graphDiv1,
                    #chartDiv5,
                    #graphDiv2,
                    #donut,
                    #donut2 {
                      height: 300px; /* Adjust height for smaller devices */
                    }
                  }
                
                  /* Add more media queries as needed */
                </style>
          
          <!-- Resources -->
          
          
          <!-- Chart code -->
          <script>
      
          </script>
          
     
    </div>
    
  </div>
 </section>
